import createNormalizer from 'utils/createNormalizer';

import { dashboardSchemaEntity } from '../schemas';

export const normalizeSeries = createNormalizer({
  dashboard: dashboardSchemaEntity,
});
